import { FC, useState } from "react";
import { RewardsTitle } from "./styles";
import { H4 } from "components/atoms/Heading";
import AvailableServices from "./AvailableServices";
import styled from "styled-components";
import { GlobalRewardPaginationMobile } from "../GlobalRewardPaginationMobile";
import { noServices } from ".";
import { CountryServices, Reward } from "components/pages/GlobalRewards/types";
import Image from "next/image";

interface GlobalRewardsModalMobile {
  countryDetails: CountryDetails;
  rewards: Reward[];
  resetCountryModalOnChange?: () => void;
}

export interface CountryDetails {
  code: string;
  country: string;
  continent: string;
  services?: CountryServices;
}

export const GlobalRewardsModalMobile: FC<GlobalRewardsModalMobile> = ({
  countryDetails: { country, services },
  rewards,
  resetCountryModalOnChange,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 12;
  const totalItems = rewards.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentRewards = rewards.slice(startIndex, endIndex);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div>
      <div>
        <Title>{country}</Title>
        <AvailableServices services={services || noServices} />
      </div>
      <RewardsTitle>Rewards in this country:</RewardsTitle>
      <MobileRewardsSection>
        {currentRewards && currentRewards
          ? currentRewards.map(({ name, listItemImage }, index) => (
              <MobileReward
                height={177}
                width={205}
                key={name + index}
                src={listItemImage}
                alt={`${name} logo`}
                priority
              />
            ))
          : null}
      </MobileRewardsSection>
      {totalPages > 1 && (
        <GlobalRewardPaginationMobile
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      )}
    </div>
  );
};

export default GlobalRewardsModalMobile;

export const Title = styled(H4)`
  margin-bottom: 1.25rem;
  font-size: 1.5rem;
`;

export const MobileReward = styled(Image)`
  height: 100%;
  max-width: 100%;
  object-fit: cover;
  border-radius: 0.5rem;
`;

export const MobileRewardsSection = styled.div`
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(auto-fill, minmax(30%, 1fr));

  @media only screen and (max-width: 30rem) {
    gap: 0.5rem;
  }
`;
